import React from "react";
import { Store } from "./indexeddb";
import { S3Syncer } from "./sync/s3";

export const StoreContext = React.createContext<Store>(null as unknown as any);
